//library
import { CImage, CToast, CToastBody, CToastClose, CToaster } from '@coreui/react-pro'
import React from 'react'
import PropTypes from 'prop-types'

//assets
import successIcon from '../../asset/icon/Success.svg'
import infoIcon from '../../asset/icon/Info-blue.svg'
import errorIcon from '../../asset/icon/alert-red.svg'
import alertIcon from '../../asset/icon/alert-orange.svg'

//styles
import './toast-message.style.scss'
import { useDispatch } from 'react-redux'
import { setDisplayMessage } from 'src/redux/slices/login.slice'
import { closeIcon } from 'src/asset/icon'

/**
@param
 @key {String} message : '' ,
 @key {String} type : default value is 'success',
 @key {Bool} autoHide : default value is false ,
 @key {String} placement : default value is top-center ,
 @key {String} size : default value is lg ,

*/

const setImage = (type) => {
  switch (type) {
    case 'information':
      return infoIcon
    case 'alert':
      return alertIcon
    case 'error':
      return errorIcon
    default:
      return successIcon
  }
}

const ToastMessage = (props) => {
  const {
    message,
    type,
    autoHide,
    size,
    placement,
  } = props
  
  const dispatch = useDispatch()

  const handleOnClosed = () => {
    dispatch(setDisplayMessage(null))
  }

  return (
    <CToaster placement={placement}>
      {message && <CToast
        autohide={autoHide}
        delay={3000}
        visible={true}
        className={`toast-message toast-message--${size} toast-message--${type}`}
        onClose={handleOnClosed}
        size={size}
      >
        <div className="d-flex align-items-start m-auto gap-2">
          <div className="d-flex justify-content-start flex-grow-1 toast-message__box">
            <CToastBody className="d-flex justify-content-start align-items-start gap-2 p-0">
              <CImage src={setImage(type)} id='toastMessageIcon' />
              <p id='toastMessageText' className="toast-message__text m-0 align-self-center">
                <span className="toast-message__title">{type} : </span>
                {message}
              </p>
            </CToastBody>
          </div>
          <CImage id='toastMessageCloseIcon' src={closeIcon} alt='close' className='cursor-pointer pt-1' onClick={handleOnClosed}/>
        </div>
      </CToast>}
    </CToaster>
  )
}

ToastMessage.defaultProps = {
  message : null,
  type : 'success',
  autoHide : true,
  size : 'lg',
  placement : 'top-center',
}

ToastMessage.propTypes = {
  message: PropTypes.string,
  type: PropTypes.oneOf(['information', 'success', 'error', 'alert']),
  autoHide: PropTypes.bool,
  size: PropTypes.oneOf(['lg', 'md']),
  placement: PropTypes.oneOf([
    'top-start',
    'top-center',
    'top-end',
    'bottom-start',
    'bottom-center',
    'bottom-end',
  ]),
}

export default ToastMessage
